import { ViewerMode } from '../../viewer/ViewerMode';

/**
 * 测量拾取候选集模式族。
 *
 * 设计说明：按底层工作场景收敛候选集规则，避免为每个 ViewerMode 复制测量 Handler。
 */
export enum MeasurePickScopeFamily {
    /** 零件空闲态（Default）。 */
    PartIdle = 'part-idle',
    /** 装配体浏览与装配命令族。 */
    Assembly = 'assembly',
    /** 草图相关模式族。 */
    Sketch = 'sketch',
    /** 零件基准命令族。 */
    Reference = 'reference',
    /** 装配体基准命令族。 */
    AssemblyReference = 'assembly-reference',
}

/**
 * 将底层 Viewer 模式映射为测量拾取模式族。
 *
 * @param baseViewerMode 进入测量时记录的底层模式。
 * @returns 测量拾取模式族。
 */
export function resolveMeasurePickScopeFamily(baseViewerMode: ViewerMode): MeasurePickScopeFamily {
    switch (baseViewerMode) {
        case ViewerMode.Default:
            return MeasurePickScopeFamily.PartIdle;
        case ViewerMode.Assembly:
        case ViewerMode.MoveComponent:
        case ViewerMode.LinearComponentPattern:
            return MeasurePickScopeFamily.Assembly;
        case ViewerMode.Sketch:
        case ViewerMode.SketchDrawing:
        case ViewerMode.SketchMoveEntities:
        case ViewerMode.SketchCopyEntities:
        case ViewerMode.SketchRotateEntities:
        case ViewerMode.SketchCircularPattern:
        case ViewerMode.SketchMirrorEntities:
        case ViewerMode.SketchTrim:
        case ViewerMode.SketchDimension:
            return MeasurePickScopeFamily.Sketch;
        case ViewerMode.ReferencePlane:
        case ViewerMode.ReferenceAxis:
        case ViewerMode.ReferencePoint:
            return MeasurePickScopeFamily.Reference;
        case ViewerMode.AssemblyReferencePlane:
        case ViewerMode.AssemblyReferenceAxis:
        case ViewerMode.AssemblyReferencePoint:
            return MeasurePickScopeFamily.AssemblyReference;
        default:
            return MeasurePickScopeFamily.PartIdle;
    }
}
